import React from "react";
import { useSelector } from "react-redux";
import { Alert, IconButton, Snackbar } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { IStoreState } from "../../redux/initialStoreState";
import { hideGlobalMessage } from "../../redux/globalMessages/globalMessagesSlice";
import { SuccessErrorDialog } from "../MessagesDialogs/SuccessErrorDialog/SuccessErrorDialog";
import LoadingDialog from "../Dialogs/LoadingDialog";
import { useDispatchWrapper } from "../../hooks";

export const GlobalMessagesRender: React.FC = () => {
  const dispatch = useDispatchWrapper();
  const currentMessage = useSelector(
    (state: IStoreState) => state.globalMessages.currentMessage
  );
  const loaderCount = useSelector(
    (state: IStoreState) => state.globalMessages.loaderCount
  );

  const handleClearMessage = () => {
    dispatch(hideGlobalMessage());
  };

  if (currentMessage) {
    if (currentMessage.displayAs === "snackbar") {
      return (
        <>
          <Snackbar
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
            open={true}
            autoHideDuration={5000}
            onClose={handleClearMessage}
            key={"topright"}
          >
            <Alert
              severity={currentMessage.type}
              action={
                <IconButton
                  aria-label="close"
                  color="inherit"
                  size="small"
                  onClick={handleClearMessage}
                >
                  <CloseIcon fontSize="inherit" />
                </IconButton>
              }
            >
              {currentMessage.message}
            </Alert>
          </Snackbar>
          <LoadingDialog open={loaderCount > 0} />
        </>
      );
    } else if (currentMessage.displayAs === "dialog") {
      return (
        <>
          <SuccessErrorDialog
            open={true}
            type={currentMessage.type}
            content={currentMessage.message}
            onClose={handleClearMessage}
          />
          <LoadingDialog open={loaderCount > 0} />
        </>
      );
    }
  }

  if (loaderCount > 0) {
    return <LoadingDialog open={true} />;
  }

  return <></>;
};
